import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Kpi from './PrototypeKpi';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';

class PrototypeFeedback extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            locale: props.locale,
        };

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }



    render() {
        return (
            <div className="prototype feedback-wrapper">
                <div className={`feedback-panel reflective`}>
                    <div className="feedback-content-col">
                        <Kpi/>
                        <div dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_TEXT}}/>
                    </div>
                </div>
            </div>
        );
    }
}

PrototypeFeedback.propTypes = {
    locale: PropTypes.object,
};

PrototypeFeedback.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};

}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrototypeFeedback);



/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/PrototypeFeedback.js
 **/